// import api from 'api'
import api from '@/libs/axiosInstance';

class ProjectService {

    saveFile(id,section,file,data){
        const payload = new FormData();
        if(section==='feeder'){
            payload.append('loadProfileFile', file);
        }
        if(section==='state'){
            payload.append('stateLevelLoadProfileFile', file);
        }
        if(section==='margine'){
            payload.append('marginalCostOfReplacedEnergyMetricFile', file);
        }
        payload.append('title', data.title);
        payload.append('analysisLevel', data.analysisLevel);
        payload.append('technologyType', data.technologyType);
        payload.append('status', data.status);
        
        return api.put(`user-projects/${id}`,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    publishProject(id, published) {
        return api.patch(`projects/${id}`, { published: published });
    }
    deleteProject(id) {
        api.delete(`projects/${id}`);
    }
    getProject(id) {
        api.get(`projects/${id}`);
    }
    cloneProject(id){
       return api.post(`projects/${id}/clone`);
    }
    createProject(data, section) {
        const payload = new FormData();

        if (section === 'project-data') {
            payload.append('title', data.title);
            payload.append('analysisLevel', data.analysisLevel);
            payload.append('technologyType', data.technologyType);
        }

        else {

            payload.append('title', data.title);
            payload.append('analysisLevel', data.analysisLevel);
            payload.append('technologyType', data.technologyType);
            payload.append('stateLevelDistributedSolarEnergyCapacityAddition', data.stateLevelDistributedSolarEnergyCapacityAddition);

            payload.append('feederData.substationName', data.substationName);
            payload.append('feederData.pincode', data.feederData.pincode);
            payload.append('feederData.stateName', data.feederData.stateName);
            payload.append('feederData.profileType', data.feederData.profileType);
            payload.append('feederData.feederType', data.feederData.feederType);
            payload.append('feederData.yearlyChangeInLoadPercent', data.feederData.yearlyChangeInLoadPercent);
            payload.append('feederData.conductorType.title', data.feederData.conductorType.title);
            payload.append('feederData.conductorType.reactanceOhmsPerKm', data.feederData.conductorType.reactanceOhmsPerKm);
            payload.append('feederData.conductorType.resistanceOhmsPerKm', data.feederData.conductorType.resistanceOhmsPerKm);
            payload.append('feederData.conductorType.peakCurrentCarryingCapacityAmps', data.feederData.conductorType.peakCurrentCarryingCapacityAmps);

            payload.append('feederData.analysisPeriod', data.feederData.analysisPeriod);
            payload.append('feederData.capacityUpgradationUpperLimit', data.feederData.capacityUpgradationUpperLimit);
            payload.append('feederData.loadShiftedAfterUpgradation', data.feederData.loadShiftedAfterUpgradation);
            payload.append('feederData.powerFactor', data.feederData.powerFactor);
            // payload.append('feederData.sanctionedLoadMW', data.feederData.sanctionedLoadMW);

            if (data.analysisLevel === 'dt') {
                payload.append('feederData.dtName', data.feederDtName);
                payload.append('feederData.dtTapping', data.feederData.dtTapping);
                payload.append('feederData.dtCapacityKVA', data.feederData.dtCapacityKVA);
                payload.append('feederData.primaryVoltage', data.feederData.primaryVoltage);
                payload.append('feederData.secondaryVoltage', data.feederData.secondaryVoltage);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear',data.feederData.year);

                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                    payload.append('loadProfileYear',data.feederData.year);
                }
            }

            if (data.analysisLevel === 'feeder') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederVoltageKV', data.feederData.feederVoltageKV);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear',data.feederData.year);
                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                    payload.append('loadProfileYear',data.feederData.year);
                }
            }
            if (data.analysisLevel === 'substation') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);
                payload.append('feederData.incomingFeederVoltageKV', data.feederData.incomingFeederVoltageKV);
                payload.append('feederData.outgoingFeederVoltageKV', data.feederData.outgoingFeederVoltageKV);
                payload.append('feederData.totalCapacityMVA', data.feederData.totalCapacityMVA);
                payload.append('feederData.feederCount', data.feederData.feederCount);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear',data.feederData.year);

                }
                else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                    payload.append('loadProfileYear',data.feederData.year);
                }

            }
            // state level profile
            if (data.feederData.stateLevelProfile.csvFile !== null) {
                payload.append('stateLevelLoadProfileTitle', data.feederData.stateLevelProfile.title);
                payload.append('stateLevelLoadProfileYear', data.feederData.stateLevelProfile.year);
                payload.append('stateLevelLoadProfileFile', data.feederData.stateLevelProfile.csvFile);
            }
            else if (data.feederData.stateLevelProfile.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.feederData.stateLevelProfile.profileId);
            }
            else if (data.feederData.stateLevelProfile.csvFile === null && data.feederData.stateLevelProfile.profileId === null) {
                payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.feederData.stateLevelProfile.peakLoadDemandMW);
                payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.feederData.stateLevelProfile.peakLoadEventTime);
            }

        }

        payload.append('status', data.status);
 

        return api.post('user-projects',
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    updateProjectFeeder(id,data){
        const payload = new FormData();

        payload.append('feederData.substationName', data.substationName);
        payload.append('feederData.pincode', data.feederData.pincode);
        payload.append('feederData.stateName', data.feederData.stateName);
        payload.append('feederData.profileType', data.feederData.profileType);
        payload.append('feederData.feederType', data.feederData.feederType);
        payload.append('feederData.yearlyChangeInLoadPercent', data.feederData.yearlyChangeInLoadPercent);
        payload.append('feederData.conductorType.title', data.feederData.conductorType.title);
        payload.append('feederData.conductorType.reactanceOhmsPerKm', data.feederData.conductorType.reactanceOhmsPerKm);
        payload.append('feederData.conductorType.resistanceOhmsPerKm', data.feederData.conductorType.resistanceOhmsPerKm);
        payload.append('feederData.conductorType.peakCurrentCarryingCapacityAmps', data.feederData.conductorType.peakCurrentCarryingCapacityAmps);

        payload.append('feederData.analysisPeriod', data.feederData.analysisPeriod);
        payload.append('feederData.capacityUpgradationUpperLimit', data.feederData.capacityUpgradationUpperLimit);
        payload.append('feederData.loadShiftedAfterUpgradation', data.feederData.loadShiftedAfterUpgradation);
        payload.append('feederData.powerFactor', data.feederData.powerFactor);

        if (data.analysisLevel === 'dt') {
            payload.append('feederData.dtName', data.feederDtName);
            payload.append('feederData.dtTapping', data.feederData.dtTapping);
            payload.append('feederData.dtCapacityKVA', data.feederData.dtCapacityKVA);
            payload.append('feederData.primaryVoltage', data.feederData.primaryVoltage);
            payload.append('feederData.secondaryVoltage', data.feederData.secondaryVoltage);
            payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);
            // payload.append('feederData.sanctionedLoadMW', data.feederData.sanctionedLoadMW);

            if (data.feederData.csvFile !== null) {
                payload.append('loadProfileFile', data.feederData.csvFile);
                payload.append('loadProfileTitle', data.feederData.title);
                payload.append('loadProfileYear', data.feederData.year);

            } else if (data.feederData.profileId !== null) {
                payload.append('loadProfileId', data.feederData.profileId);
            }
        }

        if (data.analysisLevel === 'feeder') {
            payload.append('feederData.feederName', data.feederDtName);
            payload.append('feederData.feederVoltageKV', data.feederData.feederVoltageKV);
            payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

            if (data.feederData.csvFile !== null) {
                payload.append('loadProfileFile', data.feederData.csvFile);
                payload.append('loadProfileTitle', data.feederData.title);
                payload.append('loadProfileYear', data.feederData.year);
            } else if (data.feederData.profileId !== null) {
                payload.append('loadProfileId', data.feederData.profileId);
            }
        }
        if (data.analysisLevel === 'substation') {
            payload.append('feederData.feederName', data.feederDtName);
            payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);
            payload.append('feederData.incomingFeederVoltageKV', data.feederData.incomingFeederVoltageKV);
            payload.append('feederData.outgoingFeederVoltageKV', data.feederData.outgoingFeederVoltageKV);
            payload.append('feederData.totalCapacityMVA', data.feederData.totalCapacityMVA);
            payload.append('feederData.feederCount', data.feederData.feederCount);

            if (data.feederData.csvFile !== null) {
                payload.append('loadProfileFile', data.feederData.csvFile);
                payload.append('loadProfileTitle', data.feederData.title);
                payload.append('loadProfileYear', data.feederData.year);

            }
            else if (data.feederData.profileId !== null) {
                payload.append('loadProfileId', data.feederData.profileId);
            }

        }
        // state level profile
        if (data.feederData.stateLevelProfile.csvFile !== null) {
            payload.append('stateLevelLoadProfileTitle', data.feederData.stateLevelProfile.title);
            payload.append('stateLevelLoadProfileFile', data.feederData.stateLevelProfile.csvFile);
            payload.append('stateLevelLoadProfileYear', data.feederData.stateLevelProfile.year);
        }
        else if (data.feederData.stateLevelProfile.profileId !== null) {
            payload.append('feederData.stateLevelProfile.profileId', data.feederData.stateLevelProfile.profileId);
        }
        else if (data.feederData.stateLevelProfile.csvFile === null && data.feederData.stateLevelProfile.profileId === null) {
            payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.feederData.stateLevelProfile.peakLoadDemandMW);
            payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.feederData.stateLevelProfile.peakLoadEventTime);
        }

        payload.append('status', data.status);
        payload.append('isCloned', data.isCloned);
        return api.patch(`user-projects/${id}`,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    updateProjectTitle(id, title,technologyType){
        const payload = new FormData();
        payload.append('title', title);
        payload.append('technologyType', technologyType);
        return api.patch(`user-projects/${id}`, payload);
    }
    updateInitialProject(id, data, section) {
        const payload = new FormData();

        if (section === 'project-data') {
            payload.append('title', data.title);
            payload.append('analysisLevel', data.analysisLevel);
            payload.append('technologyType', data.technologyType);
        }

        else {

            payload.append('title', data.title);
            payload.append('analysisLevel', data.analysisLevel);
            payload.append('technologyType', data.technologyType);
            payload.append('stateLevelDistributedSolarEnergyCapacityAddition', data.stateLevelDistributedSolarEnergyCapacityAddition);

            payload.append('feederData.substationName', data.substationName);
            payload.append('feederData.pincode', data.feederData.pincode);
            payload.append('feederData.stateName', data.feederData.stateName);
            payload.append('feederData.profileType', data.feederData.profileType);
            payload.append('feederData.feederType', data.feederData.feederType);
            payload.append('feederData.yearlyChangeInLoadPercent', data.feederData.yearlyChangeInLoadPercent);
            payload.append('feederData.conductorType.title', data.feederData.conductorType.title);
            payload.append('feederData.conductorType.reactanceOhmsPerKm', data.feederData.conductorType.reactanceOhmsPerKm);
            payload.append('feederData.conductorType.resistanceOhmsPerKm', data.feederData.conductorType.resistanceOhmsPerKm);
            payload.append('feederData.conductorType.peakCurrentCarryingCapacityAmps', data.feederData.conductorType.peakCurrentCarryingCapacityAmps);

            payload.append('feederData.analysisPeriod', data.feederData.analysisPeriod);
            payload.append('feederData.capacityUpgradationUpperLimit', data.feederData.capacityUpgradationUpperLimit);
            payload.append('feederData.loadShiftedAfterUpgradation', data.feederData.loadShiftedAfterUpgradation);
            payload.append('feederData.powerFactor', data.feederData.powerFactor);
            // payload.append('feederData.sanctionedLoadMW', data.feederData.sanctionedLoadMW);

            if (data.analysisLevel === 'dt') {
                payload.append('feederData.dtName', data.feederDtName);
                payload.append('feederData.dtTapping', data.feederData.dtTapping);
                payload.append('feederData.dtCapacityKVA', data.feederData.dtCapacityKVA);
                payload.append('feederData.primaryVoltage', data.feederData.primaryVoltage);
                payload.append('feederData.secondaryVoltage', data.feederData.secondaryVoltage);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);

                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                }
            }

            if (data.analysisLevel === 'feeder') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederVoltageKV', data.feederData.feederVoltageKV);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);
                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                }
            }
            if (data.analysisLevel === 'substation') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);
                payload.append('feederData.incomingFeederVoltageKV', data.feederData.incomingFeederVoltageKV);
                payload.append('feederData.outgoingFeederVoltageKV', data.feederData.outgoingFeederVoltageKV);
                payload.append('feederData.totalCapacityMVA', data.feederData.totalCapacityMVA);
                payload.append('feederData.feederCount', data.feederData.feederCount);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);

                }
                else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                }

            }
            // state level profile
            if (data.feederData.stateLevelProfile.csvFile !== null) {
                payload.append('stateLevelLoadProfileTitle', data.feederData.stateLevelProfile.title);
                payload.append('stateLevelLoadProfileFile', data.feederData.stateLevelProfile.csvFile);
                payload.append('stateLevelLoadProfileYear', data.feederData.stateLevelProfile.year);
            }
            else if (data.feederData.stateLevelProfile.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.feederData.stateLevelProfile.profileId);
            }
            else if (data.feederData.stateLevelProfile.csvFile === null && data.feederData.stateLevelProfile.profileId === null) {
                payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.feederData.stateLevelProfile.peakLoadDemandMW);
                payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.feederData.stateLevelProfile.peakLoadEventTime);
            }

        }

        payload.append('status', data.status);

        return api.put(`user-projects/${id}`,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    getMultiFormData(object) {
        if (Object.keys(object).length > 0) {
            const formData = new FormData();
            Object.keys(object).forEach(key => formData.append(key, object[key]));
            return formData;
        }
        else {
            return object;
        }
    }
    updateClonedProjectTechnologyVoder(id, data) {

        const payload = new FormData();
            payload.append('title', data.title);
            payload.append('analysisLevel', data.analysisLevel);
            payload.append('technologyType', data.technologyType);
            payload.append('stateLevelDistributedSolarEnergyCapacityAddition', data.stateLevelDistributedSolarEnergyCapacityAddition);

            payload.append('feederData.substationName', data.substationName);
            payload.append('feederData.pincode', data.feederData.pincode);
            payload.append('feederData.stateName', data.feederData.stateName);
            payload.append('feederData.profileType', data.feederData.profileType);
            payload.append('feederData.feederType', data.feederData.feederType);
            payload.append('feederData.yearlyChangeInLoadPercent', data.feederData.yearlyChangeInLoadPercent);
            payload.append('feederData.conductorType.title', data.feederData.conductorType.title);
            payload.append('feederData.conductorType.reactanceOhmsPerKm', data.feederData.conductorType.reactanceOhmsPerKm);
            payload.append('feederData.conductorType.resistanceOhmsPerKm', data.feederData.conductorType.resistanceOhmsPerKm);
            payload.append('feederData.conductorType.peakCurrentCarryingCapacityAmps', data.feederData.conductorType.peakCurrentCarryingCapacityAmps);

            payload.append('feederData.analysisPeriod', data.feederData.analysisPeriod);
            payload.append('feederData.capacityUpgradationUpperLimit', data.feederData.capacityUpgradationUpperLimit);
            payload.append('feederData.loadShiftedAfterUpgradation', data.feederData.loadShiftedAfterUpgradation);
            payload.append('feederData.powerFactor', data.feederData.powerFactor);
            // payload.append('feederData.sanctionedLoadMW', data.feederData.sanctionedLoadMW);

            if (data.analysisLevel === 'dt') {
                payload.append('feederData.dtName', data.feederDtName);
                payload.append('feederData.dtTapping', data.feederData.dtTapping);
                payload.append('feederData.dtCapacityKVA', data.feederData.dtCapacityKVA);
                payload.append('feederData.primaryVoltage', data.feederData.primaryVoltage);
                payload.append('feederData.secondaryVoltage', data.feederData.secondaryVoltage);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);
                    payload.append('loadProfileId',null);

                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileTitle',null)
                    payload.append('loadProfileId', data.feederData.profileId);
                }
            }

            if (data.analysisLevel === 'feeder') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederVoltageKV', data.feederData.feederVoltageKV);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);
                    payload.append('loadProfileId', null);
                } else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                    payload.append('loadProfileTitle',null);
                }
            }
            if (data.analysisLevel === 'substation') {
                payload.append('feederData.feederName', data.feederDtName);
                payload.append('feederData.feederLengthKm', data.feederData.feederLengthKm);
                payload.append('feederData.incomingFeederVoltageKV', data.feederData.incomingFeederVoltageKV);
                payload.append('feederData.outgoingFeederVoltageKV', data.feederData.outgoingFeederVoltageKV);
                payload.append('feederData.totalCapacityMVA', data.feederData.totalCapacityMVA);
                payload.append('feederData.feederCount', data.feederData.feederCount);

                if (data.feederData.csvFile !== null) {
                    payload.append('loadProfileFile', data.feederData.csvFile);
                    payload.append('loadProfileTitle', data.feederData.title);
                    payload.append('loadProfileYear', data.feederData.year);
                    payload.append('loadProfileId',null);

                }
                else if (data.feederData.profileId !== null) {
                    payload.append('loadProfileId', data.feederData.profileId);
                    payload.append('loadProfileTitle', null);
                }

            }
            // state level profile
            if (data.feederData.stateLevelProfile.csvFile !== null) {
                payload.append('stateLevelLoadProfileTitle', data.feederData.stateLevelProfile.title);
                payload.append('stateLevelLoadProfileFile', data.feederData.stateLevelProfile.csvFile);
                payload.append('stateLevelLoadProfileYear', data.feederData.stateLevelProfile.data);
            }
            else if (data.feederData.stateLevelProfile.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.feederData.stateLevelProfile.profileId);
                payload.append('stateLevelLoadProfileTitle',null);
            }
            else if (data.feederData.stateLevelProfile.csvFile === null && data.feederData.stateLevelProfile.profileId === null) {
                payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.feederData.stateLevelProfile.peakLoadDemandMW);
                payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.feederData.stateLevelProfile.peakLoadEventTime);
                payload.append('stateLevelLoadProfileTitle',null);
                
            }

              //TECHNOLOGY DATA -- START
        if (data.technologyType === 'solar') {
            if (data.technologyData.interconnectionLocationSolar !== null) {
                payload.append('technologyData.interconnectionLocationSolar', data.technologyData.interconnectionLocationSolar);
            }
            if (data.technologyData.solarCapacity !== null) {
                payload.append('technologyData.solarCapacity', data.technologyData.solarCapacity);
            }
        }
        else if (data.technologyType === 'storage') {
            if (data.technologyData.interconnectionLocationStorage !== null) {
                payload.append('technologyData.interconnectionLocationStorage', data.technologyData.interconnectionLocationStorage);
            }
            if (data.technologyData.storageCapacity !== null) {
                payload.append('technologyData.storageCapacity', data.technologyData.storageCapacity);
            }
            if (data.technologyData.inverterCapacityForStorage !== null) {
                payload.append('technologyData.inverterCapacityForStorage', data.technologyData.inverterCapacityForStorage);
            }
        }
        else if (data.technologyType === 'solar_plus_storage') {
            if (data.technologyData.interconnectionLocationSolar !== null) {
                payload.append('technologyData.interconnectionLocationSolar', data.technologyData.interconnectionLocationSolar);
            }
            if (data.technologyData.interconnectionLocationStorage !== null) {
                payload.append('technologyData.interconnectionLocationStorage', data.technologyData.interconnectionLocationStorage);
            }
            if (data.technologyData.inverterCapacityForStorage !== null) {
                payload.append('technologyData.inverterCapacityForStorage', data.technologyData.inverterCapacityForStorage);
            }
            if (data.technologyData.solarCapacity !== null) {
                payload.append('technologyData.solarCapacity', data.technologyData.solarCapacity);
            }
            if (data.technologyData.storageCapacity !== null) {
                payload.append('technologyData.storageCapacity', data.technologyData.storageCapacity);
            }
            if (data.technologyData.storageChargingDischargingStrategy !== null) {
                payload.append('technologyData.storageChargingDischargingStrategy', data.technologyData.storageChargingDischargingStrategy);
            }
        }
        //TECHNOLOGY DATA -- END
        //VODER DATA
            if (data.voderData.marginalCostOfReplacedEnergyMetricType !== null || data.voderData.marginalCostOfReplacedEnergyMetricType !== '') {
                if (data.voderData.marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'
                    || data.voderData.marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data') {
                    if (data.voderData.csvFile) {
                        payload.append('marginalCostOfReplacedEnergyMetricType', data.voderData.marginalCostOfReplacedEnergyMetricType);
                        payload.append('marginalCostOfReplacedEnergyMetricFile', data.voderData.csvFile);
                        payload.append('marginalCostOfReplacedEnergyMetricYear', data.voderData.marginalCostOfReplacedEnergyMetricYear);
                    }
                }
                if (data.voderData.marginalCostOfReplacedEnergyMetricType === 'marginal_cost_of_generator_to_be_replaced') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.voderData.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricData', data.voderData.marginalCostOfReplacedEnergyMetricData);
                }

                if (data.voderData.marginalCostOfReplacedEnergyMetricType === 'database') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.voderData.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricRecord', data.voderData.marginalCostOfReplacedEnergyMetricData);
                }
            }

            if (data.voderData.transmissionCapacityCost !== null) {
                payload.append('voderData.transmissionCapacityCost', data.voderData.transmissionCapacityCost);
            }
            if (data.voderData.generationCapacityCost !== null) {
                payload.append('voderData.generationCapacityCost', data.voderData.generationCapacityCost);
            }

            if (data.voderData.discountFactor !== null) {
                payload.append('voderData.discountFactor', data.voderData.discountFactor);
            }
            if (data.voderData.interestRate !== null) {
                payload.append('voderData.interestRate', data.voderData.interestRate);
            }


            if (data.voderData.avgTransmissionLosses) {
                payload.append('voderData.avgTransmissionLosses', data.voderData.avgTransmissionLosses);
            }

            if (data.voderData.upgradationCost.analysisLevel !== null) {
                payload.append('voderData.upgradationCost.analysisLevel', data.voderData.upgradationCost.analysisLevel);
            }
            if (data.voderData.upgradationCost.voltageLevelsKV !== null) {
                payload.append('voderData.upgradationCost.voltageLevelsKV', data.voderData.upgradationCost.voltageLevelsKV);
            }
            if (data.voderData.upgradationCost.feederType !== null) {
                payload.append('voderData.upgradationCost.feederType', data.voderData.upgradationCost.feederType);
            }
            if (data.voderData.upgradationCost.costInLakhs !== null) {
                payload.append('voderData.upgradationCost.costInLakhs', data.voderData.upgradationCost.costInLakhs);
            }
            if (data.voderData.emissionCosts.emissionCostCo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostCo2', data.voderData.emissionCosts.emissionCostCo2);
            }
            if (data.voderData.emissionCosts.emissionCostNo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostNo2', data.voderData.emissionCosts.emissionCostNo2);
            }
            if (data.voderData.emissionCosts.emissionCostSo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSo2', data.voderData.emissionCosts.emissionCostSo2);
            }
            if (data.voderData.emissionCosts.emissionCostSPM2_5 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSPM2_5', data.voderData.emissionCosts.emissionCostSPM2_5);
            }

            payload.append('status', data.status);
            payload.append('isCloned', data.isCloned);

        return api.patch(`user-projects/${id}`,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });


        
    }
    updateProjectTechnologyVoder(id, data, status, dataSection) {
        let payload = {}

        if (dataSection === 3) { // technology data
            let technologyData = {};
            for (let key in data) {
                if (data[key] !== null && data[key] != "")
                    technologyData[key] = data[key]
            }
            payload = {
                technologyData: technologyData,
                status: status
            }

            return api.patch(`user-projects/${id}`, payload);
        }


        if (dataSection === 4) { // voder data
            const payload = new FormData();

            if (data.marginalCostOfReplacedEnergyMetricType !== null || data.marginalCostOfReplacedEnergyMetricType !== '') {
                if (data.marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'
                    || data.marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data') {
                    if (data.marginalCostOfReplacedEnergyMetricDataFile) {
                        payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                        payload.append('marginalCostOfReplacedEnergyMetricFile', data.marginalCostOfReplacedEnergyMetricDataFile);
                        payload.append('marginalCostOfReplacedEnergyMetricYear', data.marginalCostOfReplacedEnergyMetricYear);
                    }
                }
                if (data.marginalCostOfReplacedEnergyMetricType === 'marginal_cost_of_generator_to_be_replaced') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricData', data.marginalCostOfReplacedEnergyMetricData);
                }

                if (data.marginalCostOfReplacedEnergyMetricType === 'database') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricRecord', data.marginalCostOfReplacedEnergyMetricData);
                }
            }

            if (data.transmissionCapacityCost !== null) {
                payload.append('voderData.transmissionCapacityCost', data.transmissionCapacityCost);
            }
            if (data.generationCapacityCost !== null) {
                payload.append('voderData.generationCapacityCost', data.generationCapacityCost);
            }

            if (data.discountFactor !== null) {
                payload.append('voderData.discountFactor', data.discountFactor);
            }
            if (data.interestRate !== null) {
                payload.append('voderData.interestRate', data.interestRate);
            }


            if (data.avgTransmissionLosses) {
                payload.append('voderData.avgTransmissionLosses', data.avgTransmissionLosses);
            }

            if (data.upgradationCost.analysisLevel !== null) {
                payload.append('voderData.upgradationCost.analysisLevel', data.upgradationCost.analysisLevel);
            }
            if (data.upgradationCost.voltageLevelsKV !== null) {
                payload.append('voderData.upgradationCost.voltageLevelsKV', data.upgradationCost.voltageLevelsKV);
            }
            if (data.upgradationCost.feederType !== null) {
                payload.append('voderData.upgradationCost.feederType', data.upgradationCost.feederType);
            }
            if (data.upgradationCost.costInLakhs !== null) {
                payload.append('voderData.upgradationCost.costInLakhs', data.upgradationCost.costInLakhs);
            }
            if (data.emissionCosts.emissionCostCo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostCo2', data.emissionCosts.emissionCostCo2);
            }
            if (data.emissionCosts.emissionCostNo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostNo2', data.emissionCosts.emissionCostNo2);
            }
            if (data.emissionCosts.emissionCostSo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSo2', data.emissionCosts.emissionCostSo2);
            }
            if (data.emissionCosts.emissionCostSPM2_5 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSPM2_5', data.emissionCosts.emissionCostSPM2_5);
            }
            payload.append('status', status);
            return api.patch('user-projects/' + id, payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
        }
    }
    newScreenupdateProjectTechnologyVoder(id, data, status, dataSection) {
        let payload = {}

        if (dataSection === 3) { // technology data
            let technologyData = {};
            for (let key in data) {
                if (data[key] !== null && data[key] != "")
                    technologyData[key] = data[key]
            }
            payload = {
                technologyData: technologyData,
                status: status
            }

            return api.patch(`user-projects/${id}`, payload);
        }


        if (dataSection === 4) { // voder data
            const payload = new FormData();

            if (data.marginalCostOfReplacedEnergyMetricType !== null || data.marginalCostOfReplacedEnergyMetricType !== '') {
                if (data.marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'
                    || data.marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data') {
                    if (data.csvFile) {
                        payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                        payload.append('marginalCostOfReplacedEnergyMetricFile', data.csvFile);
                        payload.append('marginalCostOfReplacedEnergyMetricYear', data.marginalCostOfReplacedEnergyMetricYear);
                    }
                }
                if (data.marginalCostOfReplacedEnergyMetricType === 'marginal_cost_of_generator_to_be_replaced') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricData', data.marginalCostOfReplacedEnergyMetricData);
                }

                if (data.marginalCostOfReplacedEnergyMetricType === 'database') {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricRecord', data.marginalCostOfReplacedEnergyMetricData);
                }
            }

            if (data.transmissionCapacityCost !== null) {
                payload.append('voderData.transmissionCapacityCost', data.transmissionCapacityCost);
            }
            if (data.generationCapacityCost !== null) {
                payload.append('voderData.generationCapacityCost', data.generationCapacityCost);
            }

            if (data.discountFactor !== null) {
                payload.append('voderData.discountFactor', data.discountFactor);
            }
            if (data.interestRate !== null) {
                payload.append('voderData.interestRate', data.interestRate);
            }


            if (data.avgTransmissionLosses) {
                payload.append('voderData.avgTransmissionLosses', data.avgTransmissionLosses);
            }

            if (data.upgradationCost.analysisLevel !== null) {
                payload.append('voderData.upgradationCost.analysisLevel', data.upgradationCost.analysisLevel);
            }
            if (data.upgradationCost.voltageLevelsKV !== null) {
                payload.append('voderData.upgradationCost.voltageLevelsKV', data.upgradationCost.voltageLevelsKV);
            }
            if (data.upgradationCost.feederType !== null) {
                payload.append('voderData.upgradationCost.feederType', data.upgradationCost.feederType);
            }
            if (data.upgradationCost.costInLakhs !== null) {
                payload.append('voderData.upgradationCost.costInLakhs', data.upgradationCost.costInLakhs);
            }
            if (data.emissionCosts.emissionCostCo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostCo2', data.emissionCosts.emissionCostCo2);
            }
            if (data.emissionCosts.emissionCostNo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostNo2', data.emissionCosts.emissionCostNo2);
            }
            if (data.emissionCosts.emissionCostSo2 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSo2', data.emissionCosts.emissionCostSo2);
            }
            if (data.emissionCosts.emissionCostSPM2_5 !== null) {
                payload.append('voderData.emissionCosts.emissionCostSPM2_5', data.emissionCosts.emissionCostSPM2_5);
            }
            payload.append('status', status);
            return api.patch('user-projects/' + id, payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
        }
    }
    updateProject(id, data) {
        const payload = new FormData();
        payload.append('analysisLevel', data.analysisLevel);
        payload.append('technologyType', data.technologyType);
        payload.append('title', data.title);
        payload.append('stateLevelDistributedSolarEnergyCapacityAddition', data.stateLevelDistributedSolarEnergyCapacityAddition);
        payload.append('feederData.substationName', data.substationName);
        payload.append('feederData.pincode', data.pincode);
        payload.append('feederData.stateName', data.stateName);
        payload.append('feederData.profileType', data.profileType);
        payload.append('feederData.feederType', data.feederType);
        payload.append('feederData.yearlyChangeInLoadPercent', data.yearlyChangeInLoadPercent);
        payload.append('feederData.conductorType.title', data.conductorTypeTitle);
        payload.append('feederData.conductorType.reactanceOhmsPerKm', data.reactanceOhmsPerKm);
        payload.append('feederData.conductorType.resistanceOhmsPerKm', data.resistanceOhmsPerKm);
        payload.append('feederData.conductorType.peakCurrentCarryingCapacityAmps', data.peakCurrentCarryingCapacityAmps);
        payload.append('feederData.powerFactor', data.powerFactor);
        // payload.append('feederData.sanctionedLoadMW', data.sanctionedLoadMW);

        if (data.analysisLevel === 'dt') {
            payload.append('feederData.dtName', data.dtName);
            payload.append('feederData.dtTapping', data.dtTapping);
            payload.append('feederData.dtCapacityKVA', data.dtCapacityKVA);
            payload.append('feederData.primaryVoltage', data.primaryVoltage);
            payload.append('feederData.secondaryVoltage', data.secondaryVoltage);
            payload.append('feederData.feederLengthKm', data.feederLengthKm);

            if (data.loadProfileId === null || data.loadProfileId === '') {
                if (data.feederDataCsvFile !== null) {
                    if (data.feederDataCsvFile.size > 0) {
                        payload.append('loadProfileFile', data.feederDataCsvFile);
                        payload.append('loadProfileTitle', data.loadProfileTitle);
                        payload.append('loadProfileYear', data.loadProfileYear);
                    }
                }


            } else if (data.loadProfileId !== null || data.loadProfileId !== '') {
                payload.append('loadProfileId', data.loadProfileId);
            }
            if ((data.profileId === null || data.profileId === '') && data.stateLevelCsvFile !== null) {
                payload.append('stateLevelLoadProfileTitle', data.stateLevelLoadProfileTitle);
                payload.append('stateLevelLoadProfileFile', data.stateLevelCsvFile);
                payload.append('stateLevelLoadProfileYear', data.stateLevelYear);
            }
            else if (data.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.profileId);
            }
            else if (data.stateLevelCsvFile === null && (data.profileId === null || data.profileId === '') && !data.isStateLevelFileExist) {

                payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.peakLoadDemandMW);
                payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.peakLoadEventTime);
            }
        }

        if (data.analysisLevel === 'feeder') {
            payload.append('feederData.feederName', data.feederDtName);
            payload.append('feederData.feederVoltageKV', data.feederVoltageKV);
            payload.append('feederData.feederLengthKm', data.feederLengthKm);

            if (data.loadProfileId === null) {
                if (data.feederDataCsvFile !== null) {
                    if (data.feederDataCsvFile.size > 0) {
                        payload.append('loadProfileFile', data.feederDataCsvFile);
                        payload.append('loadProfileTitle', data.title);
                        payload.append('loadProfileYear', data.year);
                    }
                }
            } else if (data.loadProfileId !== null) {
                payload.append('loadProfileId', data.loadProfileId);
            }

            if (data.profileId === null && data.stateLevelCsvFile !== null) {
                if (data.stateLevelCsvFile.size > 0) {
                    payload.append('stateLevelLoadProfileTitle', data.title);
                    payload.append('stateLevelLoadProfileFile', data.stateLevelCsvFile);
                    payload.append('stateLevelLoadProfileYear', data.stateLevelYear);
                }

            }
            else if (data.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.profileId);
            }
            else if (data.stateLevelCsvFile === null && data.profileId === '' && !data.isStateLevelFileExist) {
                if (data.stateLevelCsvFile.size === 0) {
                    payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.peakLoadDemandMW);
                    payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.peakLoadEventTime);
                }
            }
        }
        if (data.analysisLevel === 'substation') {
            payload.append('feederData.feederName', data.feederDtName);
            payload.append('feederData.feederLengthKm', data.feederLengthKm);
            payload.append('feederData.incomingFeederVoltageKV', data.incomingFeederVoltageKV);
            payload.append('feederData.outgoingFeederVoltageKV', data.outgoingFeederVoltageKV);
            payload.append('feederData.totalCapacityMVA', data.totalCapacityMVA);
            payload.append('feederData.feederCount', data.feederCount);

            if (data.loadProfileId === null) {
                if (data.feederDataCsvFile.size > 0) {
                    payload.append('loadProfileFile', data.feederDataCsvFile);
                    payload.append('loadProfileTitle', data.loadProfileTitle);
                    payload.append('loadProfileYear', data.loadProfileYear);
                }

            }
            else if (data.loadProfileId !== null) {
                payload.append('loadProfileId', data.loadProfileId);
            }

            if (data.profileId === null && data.stateLevelCsvFile !== null) {
                if (data.stateLevelCsvFile.size > 0) {
                    payload.append('stateLevelLoadProfileTitle', data.title);
                    payload.append('stateLevelLoadProfileFile', data.stateLevelCsvFile);
                    payload.append('stateLevelLoadProfileYear', data.stateLevelYear);
                }
            }
            else if (data.profileId !== null) {
                payload.append('feederData.stateLevelProfile.profileId', data.profileId);
            }
            else if (data.stateLevelCsvFile === null && data.profileId === '' && !data.isStateLevelFileExist) {
                if (data.stateLevelCsvFile.size === 0) {
                    payload.append('feederData.stateLevelProfile.peakLoadDemandMW', data.peakLoadDemandMW);
                    payload.append('feederData.stateLevelProfile.peakLoadEventTime', data.peakLoadEventTime);

                }
            }
        }

        //TECHNOLOGY DATA -- START
        if (data.technologyType === 'solar') {
            if (data.interconnectionLocationSolar !== null) {
                payload.append('technologyData.interconnectionLocationSolar', data.interconnectionLocationSolar);
            }
            if (data.solarCapacity !== null) {
                payload.append('technologyData.solarCapacity', data.solarCapacity);
            }
        }
        else if (data.technologyType === 'storage') {
            if (data.interconnectionLocationStorage !== null) {
                payload.append('technologyData.interconnectionLocationStorage', data.interconnectionLocationStorage);
            }
            if (data.storageCapacity !== null) {
                payload.append('technologyData.storageCapacity', data.storageCapacity);
            }
            if (data.inverterCapacityForStorage !== null) {
                payload.append('technologyData.inverterCapacityForStorage', data.inverterCapacityForStorage);
            }
        }
        else if (data.technologyType === 'solar_plus_storage') {
            if (data.interconnectionLocationSolar !== null) {
                payload.append('technologyData.interconnectionLocationSolar', data.interconnectionLocationSolar);
            }
            if (data.interconnectionLocationStorage !== null) {
                payload.append('technologyData.interconnectionLocationStorage', data.interconnectionLocationStorage);
            }
            if (data.inverterCapacityForStorage !== null) {
                payload.append('technologyData.inverterCapacityForStorage', data.inverterCapacityForStorage);
            }
            if (data.solarCapacity !== null) {
                payload.append('technologyData.solarCapacity', data.solarCapacity);
            }
            if (data.storageCapacity !== null) {
                payload.append('technologyData.storageCapacity', data.storageCapacity);
            }
            if (data.storageChargingDischargingStrategy !== null) {
                payload.append('technologyData.storageChargingDischargingStrategy', data.storageChargingDischargingStrategy);
            }
        }
        //TECHNOLOGY DATA -- END
        //VODER DATA

        if (data.marginalCostOfReplacedEnergyMetricType !== null || data.marginalCostOfReplacedEnergyMetricType !== '') {
            if (data.marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'
                || data.marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data') {
                if (data.marginalCostOfReplacedEnergyMetricFile) {
                    payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                    payload.append('marginalCostOfReplacedEnergyMetricFile', data.marginalCostOfReplacedEnergyMetricFile);
                    payload.append('marginalCostOfReplacedEnergyMetricYear', data.marginalCostOfReplacedEnergyMetricYear);
                }

            }
            if (data.marginalCostOfReplacedEnergyMetricType === 'marginal_cost_of_generator_to_be_replaced') {
                payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                payload.append('marginalCostOfReplacedEnergyMetricData', data.marginalCostOfReplacedEnergyMetricData);
            }

            if (data.marginalCostOfReplacedEnergyMetricType === 'database') {
                payload.append('marginalCostOfReplacedEnergyMetricType', data.marginalCostOfReplacedEnergyMetricType);
                payload.append('marginalCostOfReplacedEnergyMetricRecord', data.marginalCostOfReplacedEnergyMetricData);
            }
        }

        //VODER DATA -- END

        // if (data.capacityUpgradationUpperLimit !== null) {
        //     payload.append('voderData.capacityUpgradationUpperLimit', data.capacityUpgradationUpperLimit);
        // }
        // if (data.loadShiftedAfterUpgradation !== null) {
        //     payload.append('voderData.loadShiftedAfterUpgradation', data.loadShiftedAfterUpgradation);
        // }
        if (data.transmissionCapacityCost !== null) {
            payload.append('voderData.transmissionCapacityCost', data.transmissionCapacityCost);
        }
        if (data.generationCapacityCost !== null) {
            payload.append('voderData.generationCapacityCost', data.generationCapacityCost);
        }

        if (data.discountFactor !== null) {
            payload.append('voderData.discountFactor', data.discountFactor);
        }
        if (data.interestRate !== null) {
            payload.append('voderData.interestRate', data.interestRate);
        }

        // if (data.analysisPeriod !== null) {
        //     payload.append('voderData.analysisPeriod', data.analysisPeriod);
        // }

        if (data.avgTransmissionLosses) {
            payload.append('voderData.avgTransmissionLosses', data.avgTransmissionLosses);
        }

        if (data.analysisLevel !== null) {
            payload.append('voderData.upgradationCost.analysisLevel', data.analysisLevel);
        }
        if (data.voltageLevelsKV !== null) {
            payload.append('voderData.upgradationCost.voltageLevelsKV', data.voltageLevelsKV);
        }
        if (data.feederType !== null) {
            payload.append('voderData.upgradationCost.feederType', data.feederType);
        }
        if (data.costInLakhs !== null) {
            payload.append('voderData.upgradationCost.costInLakhs', data.costInLakhs);
        }
        if (data.emissionCostCo2 !== null) {
            payload.append('voderData.emissionCosts.emissionCostCo2', data.emissionCostCo2);
        }
        if (data.emissionCostNo2 !== null) {
            payload.append('voderData.emissionCosts.emissionCostNo2', data.emissionCostNo2);
        }
        if (data.emissionCostSo2 !== null) {
            payload.append('voderData.emissionCosts.emissionCostSo2', data.emissionCostSo2);
        }
        if (data.emissionCostSPM2_5 !== null) {
            payload.append('voderData.emissionCosts.emissionCostSPM2_5', data.emissionCostSPM2_5);
        }
        payload.append('status', data.status);

        return api.patch('user-projects/' + id, payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    updateProjectStatus(id, status) {
        return api.patch('user-projects/' + id, { status });
    }
}

export default new ProjectService();